import React from 'react';
import { useCookieConsent } from '../context/CookieConsentContext';
const CookieConsent = () => {
  const { cookieAccepted,cookieRejected, handleAcceptCookies,handleRejectCookies } = useCookieConsent();

  // Check if the user has already accepted cookies
  if (cookieAccepted || cookieRejected) return null;


  return (
    <div className="cookie-wrapper">
      <div className="cookie-container">
        <div className="flex-one">
          <h2>About cookies on this portal</h2>
          {/* <p>
            In order to provide a more relevant experience for you, we use cookies to
            enable some website functionality. In addition, other cookies may be
            used with your consent to analyze site usage, improve the user
            experience, and provide many other site benefits.
          </p> */}
          <p>This portal uses essential cookies for security, authentication,
            session management, and to remember your cookie
            preferences.
            No analytics, tracking, or third-party advertising cookies are
            used. Cookies are session-based or short duration.
            For more information, please see our <a href="https://www.smart-formations.co.uk/cookies-policy/"target="_blank" rel="noopener noreferrer">Cookie Policy</a>
          </p>
        </div>
        {/* <div className="loging_buttom w-260" style={{ display: 'flex', gap: '10px' }}>
          <button onClick={handleAcceptCookies}>Accept All</button>
          <button onClick={handleRejectCookies}>
            Reject All
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default CookieConsent;
